import {
    GET_MEMBERSHIPS,
    GET_MEMBERSHIP,
    CREATE_MEMBERSHIP,
    UPDATE_MEMBERSHIP,
    DELETE_MEMBERSHIP,
} from '../actions/types';

const initialState = {
    memberships: [],
    membership: null,
    loading: false
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_MEMBERSHIPS:
            return {
                ...state,
                memberships: payload,
                loading: false
            };
        case GET_MEMBERSHIP:
            return {
                ...state,
                membership: payload,
                loading: false
            };
        case CREATE_MEMBERSHIP:
            return {
                ...state,
                memberships: [payload, ...state.memberships],
                membership: payload,
                loading: false
            };
        case UPDATE_MEMBERSHIP:
            return {
                ...state,
                memberships: state.memberships.map(membership => 
                    membership._id === payload._id ? payload : membership
                ),
                membership: payload,
                loading: false
            };
        case DELETE_MEMBERSHIP:
            return {
                ...state,
                memberships: state.memberships.filter(membership => membership._id !== payload),
                membership: null,
                loading: false
            };
        default:
            return state;
    }
} 